export enum NotificationSource {
  PAA = 'PAA',
  PPM = 'PPM',
  DAC = 'DAC',
  AGPM = 'AGPM',
  ECLAIRCISSEMENT = 'ECLAIRCISSEMENT',
  PARAMS = 'PARAMS',
  WEBMASTER = 'WEBMASTER',
  REUNION = 'REUNION',
  SYSTEM = 'SYSTEM',
}

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  TASK_ASSIGNED = 'TASK_ASSIGNED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  DOCUMENT_UPDATED = 'DOCUMENT_UPDATED',
}

export enum NotificationPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export interface NotificationResponse {
  id: number;
  userId: string;
  title: string;
  message: string;
  source: NotificationSource;
  type: NotificationType;
  priority: NotificationPriority;
  isRead: boolean;
  readAt?: string;
  referenceId?: string;
  referenceType?: string;
  actionUrl?: string;
  metadata?: string;
  createdAt: string;
  createdBy: string;
}

export interface NotificationEvent {
  eventType: 'NEW' | 'READ' | 'READ_ALL' | 'DELETED';
  notification?: NotificationResponse;
  unreadCount: number;
  notificationId?: number;
}
